<template>
  <section class="bx-search__header bx-typo--search-header bx-filters bx-filters--thematic">
    <h2 v-if="headline">
      {{ headline }}
    </h2>
    <div class="bx-air-date-navi">
      <button type="button"
              :disabled="dayOffset <= -4"
              @click="shiftAirTime(airTime, 'prev')">
        <Icon name="arrow_pager-prev" />
      </button>
      <span>{{ displayAirDate(airTime) }}</span>
      <button type="button"
              :disabled="dayOffset >= 7"
              @click="shiftAirTime(airTime, 'next')">
        <Icon name="arrow_pager-next" />
      </button>
    </div>
  </section>
</template>

<script>
import { addDays, differenceInCalendarDays } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

import epgAirTimeHelper from '../../mixins/epg-air-time-helper'
import Icon from '../../../../../components/shared/Icon.vue'

export default {
  components: {
    Icon
  },
  mixins: [epgAirTimeHelper],
  props: {
    headline: {
      type: String,
      default: ''
    },
    airTime: {
      type: String,
      default: ''
    },
    initialAirTime: {
      type: String,
      default: null
    }
  },
  emits: ['update:air-time-filter'],
  computed: {
    // Calculates the difference in days between the initial and target air time
    dayOffset () {
      const baseAirTime = this.initialAirTime || this.airTimeNow
      const initial = utcToZonedTime(new Date(baseAirTime), this.timeZone)
      const target = utcToZonedTime(new Date(this.airTime), this.timeZone)

      return differenceInCalendarDays(target, initial)
    }
  },
  methods: {
    /**
     * Shift airTime (ISO string in UTC/Zulu) by one day.
     * @param {string} airTime - Original airTime in ISO format (e.g. "2025-09-03T11:40:00.000Z")
     * @param {'prev'|'next'} direction - Shift direction
     * @returns {string} New airTime in ISO string (UTC/Zulu)
     */
    shiftAirTime (airTime, direction) {
      const date = new Date(airTime)
      const shifted = addDays(date, direction === 'next' ? 1 : -1)
      this.$emit('update:air-time-filter', shifted.toISOString())
    }
  }
}
</script>
